import React from "react";
import { AllImages } from "../../Assets/Images/AllImages";
import "./Skills.scss";
import user from "../../Common/JsonFiles/rohan.json";

const Skills = (props) => {
  return (
    <div className="skill-container">
      <div className="skills-heading">Skills</div>

      {user?.skills?.map((item) => {
        return (
          <div className="skill-single-card">
            <div className="skill-icon-div">
              <img src={AllImages[item?.img]} alt="" width={"40px"} />
            </div>
            <div className="skill-heading">{item?.type}</div>
            <div className="skill-description">{item?.description}</div>
            <div className="skills">Things I enjoy:</div>
            <div className="skill-names">{item?.skillset?.join(", ")}</div>

            <div className="skills">Dev Tools:</div>
            <div className="skill-names">
              {item?.devTools?.map((dev) => {
                return <div className="still-tool">{dev}</div>;
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Skills;
